import React from 'react';
import './details-item-date-time.scss';
import { TimeWithTimezone } from '../../../time-in-different-time-zone';
import { DetailsItem } from '../details-item';

interface IProps {
    title: string | JSX.Element;
    time: string;
    timeZone: string;
    timeInDifferentTZ?: string;
}

const DetailsItemDateTime = (props: IProps) => {
    return (
        <DetailsItem className='date-time-details' title={props.title}>
            {props.time}
            {props.timeInDifferentTZ.valueOf() !== props.time.valueOf() &&
            <TimeWithTimezone time={props.timeInDifferentTZ} timeZone={props.timeZone} />}
        </DetailsItem>
    );
};

export { DetailsItemDateTime };